import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { API_BASE } from "../api/config";
import Layout from "../components/Layout";
import { useTable, useGlobalFilter, useSortBy } from "react-table";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";


function KotsByLogins() {
  const { username, branch, loginType } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedKot, setSelectedKot] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [branchInfo, setBranchInfo] = useState({ name: "", address: "" });
  const audioRef = useRef(null);
  const [branches, setBranches] = useState([]);
  const [tables, setTables] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [printAfterConfirm, setPrintAfterConfirm] = useState(false);
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [userCourse, setUserCourse] = useState(null);
const [courseLoaded, setCourseLoaded] = useState(false);




 const hideSelections = Number(loginType) === 5;




  /* 🔵 TRANSFER TABLE — NEW */
  const [activeTables, setActiveTables] = useState([]);
  const [transferModal, setTransferModal] = useState({
    show: false,
    kot: null,
  });
  const [newTable, setNewTable] = useState("");
  
 useEffect(() => {
  if (Number(loginType) !== 5 || !username) {
    setCourseLoaded(true); // ✅ allow normal users
    return;
  }

  const fetchUserCourse = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_logins_by_username&login_name=${encodeURIComponent(username)}`
      );

      const result = await res.json();

      if (Array.isArray(result) && result.length > 0) {
        setUserCourse(result[0].course_name || null);
      }
    } catch (err) {
      console.error("Error fetching user course:", err);
    } finally {
      setCourseLoaded(true); // ✅ VERY IMPORTANT
    }
  };

  fetchUserCourse();
}, [loginType, username]);


  
  useEffect(() => {
  const fetchBranches = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches`
      );
      const result = await res.json();
      if (Array.isArray(result)) {
        setBranches(result);
      }
    } catch (err) {
      console.error("Error fetching branches:", err);
    }
  };
  fetchBranches();
}, []);


useEffect(() => {
  const fetchCourses = async () => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=courses`
      );
      const result = await res.json();

      if (Array.isArray(result)) {
        setCourses(result);
      }
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  fetchCourses();
}, []);



useEffect(() => {
  // When branch changes, reset table and hide KOTs
  setSelectedTable(null);
}, [selectedBranch]);


useEffect(() => {
  if (!selectedBranch) {
    setTables([]);
    return;
  }
 const url = `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=get_active_table&transac=get_table_kot&condition=branch&branch=${encodeURIComponent(selectedBranch)}`;

  // ✅ Print API URL
  console.log("🔵 API URL:", url);
  fetch(
    `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=get_active_table&transac=get_table_kot&condition=branch&branch=${encodeURIComponent(selectedBranch)}`
  )
    .then((res) => res.json())
    .then((data) => {
      if (data?.status === "success") {
        if (data?.status === "success") {
  const allTables = data.data || [];

  setTables(allTables);
}

      } else {
        setTables([]);
      }
    })
    .catch((err) => {
      console.error("Failed to fetch active tables:", err);
      setTables([]);
    });
}, [selectedBranch]);


const updateKotPrintStatus = async (kot_id) => {
  try {
    await fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=update&table=update_kot_print_status&kot_id=${kot_id}`
    );
  } catch (err) {
    console.error("Failed to update print status:", err);
  }
};


const printKotByOrderRef = async (kot_id) => {
  return new Promise(async (resolve) => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_kot_by_kot_id&kot_id=${kot_id}`
      );

      const kotItems = await res.json();

      if (!Array.isArray(kotItems) || kotItems.length === 0) {
        alert("No KOT items found");
        resolve(false);
        return;
      }

      const { table_name, branch, kot_time } = kotItems[0];

      // 🔥 Build Plain Text Receipt
      let receipt = "";

      receipt += "\x1B\x61\x01"; // center align
      receipt += (branch || "Restaurant") + "\n";
      receipt += "KOT\n";
      receipt += "\x1B\x61\x00"; // left align
      receipt += "------------------------------\n";

      receipt += "Table : " + table_name + "\n";
      receipt += "KOT   : " + kot_id + "\n";
      receipt += "Time  : " + (kot_time || "") + "\n";
      receipt += "------------------------------\n";

      receipt += "Item                Qty\n";
      receipt += "------------------------------\n";

      kotItems.forEach((item) => {
        let name = (item.item_name || "").substring(0, 20).padEnd(20, " ");
        let qty = String(item.item_qty).padStart(3, " ");
        receipt += name + qty + "\n";
      });

      receipt += "------------------------------\n\n\n";

      // 🔥 Send to RawBT
      window.location.href =
        "rawbt://print?text=" + encodeURIComponent(receipt);

      resolve(true);
    } catch (err) {
      console.error("Print KOT error:", err);
      resolve(false);
    }
  });
};





  // 🔹 Fetch branch details once
  useEffect(() => {
    const fetchBranchInfo = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=tables&transac=get&condition=branch&branch=${branch}`
        );
        const result = await res.json();
        if (Array.isArray(result) && result.length > 0) {
          setBranchInfo({
            name: result[0].name || "",
            address: result[0].address || "",
          });
        }
      } catch (err) {
        console.error("Error fetching branch details:", err);
      }
    };
    fetchBranchInfo();
  }, [branch]);

  /* 🔵 TRANSFER TABLE — FETCH ACTIVE TABLES */
  useEffect(() => {
    const fetchActiveTables = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_active_table&condition=get_status_active_tables&branch=${branch}`
        );
        const result = await res.json();
        if (Array.isArray(result)) {
          setActiveTables(result); // Expect: [{table_name:"T1"}, ...]
        }
      } catch (err) {
        console.error("Error fetching active tables:", err);
      }
    };
    fetchActiveTables();
  }, [branch]);

  const baseStatusMap = useMemo(
    () => ({
      1: "Order Placed",
      2: "Order Accepted",
      3: "Food Ready",
      4: "Served",
      5: "Cancelled",
    }),
    []
  );

  const statusColors = useMemo(
    () => ({
      "Order Placed": "#facc15",
      "Order Accepted": "#22c55e",
      "Food Ready": "#3b82f6",
      "Food Preparing": "#22c55e",
      "Collect Food": "#3b82f6",
      Served: "#22c55e",
      Cancelled: "#ef4444",
    }),
    []
  );
// 🖨️ PRINT ALL ACCEPTED KOTs BY COURSE
// ...existing code...
const printAllAcceptedByCourse = async () => {
  if (!selectedCourse) {
    alert("Please select a course first");
    return;
  }

  // Get all accepted items for the selected course
  const acceptedItems = data.filter(
    (i) =>
      i.raw_status === 2 &&
      i.course_name === selectedCourse &&
      i.print_status === 0 // Only unprinted
  );

  if (acceptedItems.length === 0) {
    alert("All Accepted KOTs are printed already");
    return;
  }

  // Build one bill for all items
  let receipt = "";

  // Header (use branch/table info from first item)
  const { table_name, branch, kot_time } = acceptedItems[0] || {};
  receipt += "\x1B\x61\x01"; // center align
  receipt += (branch || "Restaurant") + "\n";
  receipt += "KOT\n";
  receipt += "\x1B\x61\x00"; // left align
  receipt += "------------------------------\n";
  receipt += "Table : " + (table_name || "") + "\n";
  receipt += "Time  : " + (kot_time || "") + "\n";
  receipt += "------------------------------\n";
  receipt += "Item                Qty\n";
  receipt += "------------------------------\n";

  acceptedItems.forEach((item) => {
    let name = (item.item_name || "").substring(0, 20).padEnd(20, " ");
    let qty = String(item.item_qty).padStart(3, " ");
    receipt += name + qty + "\n";
  });

  receipt += "------------------------------\n\n\n";

  // Print via RawBT
  window.location.href = "rawbt://print?text=" + encodeURIComponent(receipt);

  // Update print status for all items
  for (const item of acceptedItems) {
    await updateKotPrintStatus(item.raw_id);
    await new Promise((res) => setTimeout(res, 200)); // Small delay
  }

  // Optional refresh
  fetchKots();
};
// ...existing code...

  const fetchKots = useCallback(async () => {
	  if (Number(loginType) === 5 && !courseLoaded) {
  return;
}
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_today_kots_by_navy&condition=branch&branch=${branch}&login_type=${loginType}&login_name=${username}`
      );
      const result = await res.json();

      const formattedData = result.map((item, index) => {
        const rawStatus = Number(item.kot_running_status);
        let displayStatus = baseStatusMap[rawStatus] || "Unknown";
        if (rawStatus === 2) {
          displayStatus =
            Number(loginType) === 4 ? "Food Preparing" : "Order Accepted";
        } else if (rawStatus === 3) {
          displayStatus =
            Number(loginType) === 4 ? "Collect Food" : "Food Ready";
        }
        return {
          branch: item.branch,
          course_name: item.course_name,
          table_name: item.table_name,
          item_name: item.item_name,
          item_qty: item.item_qty,
		  // ✅ ADD THIS
    course_name: item.course_name || item.course || "",
          kot_running_status: displayStatus,
          raw_status: rawStatus,
  print_status: Number(item.print_status || 0), // ✅ ADD THIS
          initiated: item.kot_time,
          received: item.recieved_time,
          delivered: item.delivered_time,
          raw_id: item.id,
          order_ref: item.order_ref,
        };
      });

let finalData = formattedData;

if (Number(loginType) === 5) {
  if (!userCourse) {
    // ❌ No course assigned → show nothing
    finalData = [];
  } 
  else {
    const course = userCourse.trim().toLowerCase();

    if (course === "food") {
       // ✅ FOOD → ALL branches, ONLY Food KOTs, ONLY status = 1
      finalData = formattedData.filter(
        (i) =>
          i.course_name?.trim().toLowerCase() === "food" &&
          i.raw_status === 2
      );
    } 
    else if (course === "bar") {
       // ✅ BAR → ONLY login branch, ONLY Bar KOTs, ONLY status = 1
      finalData = formattedData.filter(
        (i) =>
          i.branch === branch &&
          i.course_name?.trim().toLowerCase() === "bar" &&
          i.raw_status === 2
      );
    } 
    else {
      // ❌ Unknown course
      finalData = [];
    }
  }
}

setData(finalData);






      setLastUpdated(new Date().toLocaleTimeString());
      setLoading(false);

      const hasPending = formattedData.some((i) => i.raw_status === 1);
      if (audioRef.current) {
        if (hasPending && audioRef.current.paused) {
          audioRef.current.play().catch(() => {});
        } else if (!hasPending && !audioRef.current.paused) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      }
    } catch (err) {
      console.error("Error fetching KOTs:", err);
      setLoading(false);
    }
  }, [branch, baseStatusMap, loginType, username, userCourse, courseLoaded]);

  useEffect(() => {
    fetchKots();
    const interval = setInterval(fetchKots, 5000);
    return () => clearInterval(interval);
  }, [fetchKots]);

  // 🔵 TRANSFER TABLE — API CALL
  const handleTransferTable = async (kotId, newTable, order_ref, old_table_name) => {
    try {
      const res = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=update&table=transfer_kot_table`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: kotId,
            table_name: newTable,
            order_ref,
            branch: branch,
            old_table_name: old_table_name,
          }),
        }
      );
      const result = await res.json();
      if (result.status === "updated" || result.status === "success") {
        fetchKots();
      } else {
        alert("Error transferring table: " + result.message);
      }
    } catch (err) {
      console.error("Error transferring table:", err);
    }
  };

  const handleTransferModal = (kot) => {
    setTransferModal({ show: true, kot });
    setNewTable(kot.table_name);
  };

  const confirmTransfer = () => {
    if (transferModal.kot && newTable) {
      handleTransferTable(
        transferModal.kot.raw_id,
        newTable,
        transferModal.kot.order_ref,
        transferModal.kot.table_name
      );
    }
    setTransferModal({ show: false, kot: null });
  };

  const cancelTransfer = () => setTransferModal({ show: false, kot: null });

  // Existing update status logic
const updateStatus = async (id, status, remark = "", order_ref = null) => {
  try {
    const payload = { id, kot_running_status: status };
    if (status === 5) payload.remark_prod = remark;

    const response = await fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=update&table=update_kot_status&condition=branch&branch=${branch}`,
      {
        method: "POST",                     // ✅ REQUIRED
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),      // ✅ REQUIRED
      }
    );

    const result = await response.json();

    if (result.status === "updated" || result.status === "success") {
      fetchKots();
    } else {
      alert("Error updating status: " + result.message);
    }
  } catch (err) {
    console.error("Error updating KOT status:", err);
  }
};


  const handleActionClick = (kot, status) => {
    setSelectedKot({ ...kot, kot_running_status: status });
    setCancelReason("");
    setShowModal(true);
  };

const confirmAction = async () => {
  if (!selectedKot) return;

  if (selectedKot.kot_running_status === 5 && !cancelReason.trim()) {
    alert("Please enter a reason for cancellation.");
    return;
  }




  // ✅ UPDATE STATUS
  await updateStatus(
    selectedKot.raw_id,
    selectedKot.kot_running_status,
    cancelReason,
    selectedKot.order_ref
  );

  setShowModal(false);
  setSelectedKot(null);
  setCancelReason("");
  setPrintAfterConfirm(false);
};


 const cancelAction = () => {
  setShowModal(false);
  setSelectedKot(null);
  setCancelReason("");
  setPrintAfterConfirm(false); // reset
};


  // TABLE COLUMNS
  const columns = useMemo(() => {
    return [
     {
  Header: "S.No",
  Cell: ({ row }) => row.index + 1,
},
      { Header: "Branch", accessor: "branch" },
      { Header: "Origin", accessor: "course_name" },
      { Header: "Table", accessor: "table_name" },
      { Header: "Item", accessor: "item_name" },
      { Header: "Qty", accessor: "item_qty" },

      {
        Header: "Status",
        accessor: "kot_running_status",
        Cell: ({ value }) => (
          <span
            className="px-2 py-1 text-xs rounded text-white"
            style={{ backgroundColor: statusColors[value] || "#777" }}
          >
            {value}
          </span>
        ),
      },


      
      {
        Header: "Actions",
        Cell: ({ row }) => {
  const r = row.original;
  const type = Number(loginType);
  const isBar = r.course_name?.trim().toLowerCase() === "bar";

  return (
    <div className="flex gap-1">
      
      {/* 🔵 IF BAR → SHOW ALL OPTIONS */}
      {isBar ? (
        <>
          <button
            className="px-2 py-1 text-xs bg-green-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
            disabled={r.raw_status >= 2}
            onClick={() => handleActionClick(r, 2)}
          >
            Accept
          </button>

          <button
            className="px-2 py-1 text-xs bg-blue-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
            disabled={r.raw_status !== 2}
            onClick={() => handleActionClick(r, 3)}
          >
            Ready
          </button>

          <button
            className="px-2 py-1 text-xs bg-green-600 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
            disabled={r.raw_status !== 3}
            onClick={() => handleActionClick(r, 4)}
          >
            Served
          </button>

          <button
            className="px-2 py-1 text-xs bg-red-500 text-white rounded"
            onClick={() => handleActionClick(r, 5)}
          >
            Cancel
          </button>
        </>
      ) : (
        /* 🔵 IF FOOD → KEEP EXISTING LOGIC */
        <>
          {(type === 2 || type === 3) && (
            <button
              className="px-2 py-1 text-xs bg-green-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
              disabled={r.raw_status >= 2}
              onClick={() => handleActionClick(r, 2)}
            >
              Accept
            </button>
          )}

          {(type === 5) && (
            <button
              className="px-2 py-1 text-xs bg-blue-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
              disabled={r.raw_status !== 2}
              onClick={() => handleActionClick(r, 3)}
            >
              Ready
            </button>
          )}

          {(type === 4 || type === 3) && (
            <button
              className="px-2 py-1 text-xs bg-green-500 text-white rounded disabled:opacity-40 disabled:cursor-not-allowed"
              disabled={r.raw_status !== 3}
              onClick={() => handleActionClick(r, 4)}
            >
              Served
            </button>
          )}

          {(type === 1 || type === 2 || type === 3) && (
            <button
              className="px-2 py-1 text-xs bg-red-500 text-white rounded"
              onClick={() => handleActionClick(r, 5)}
            >
              Cancel
            </button>
          )}
        </>
      )}
    </div>
  );
},
      },
    ];
  }, [statusColors, loginType, activeTables]);

const filteredData = useMemo(() => {
  let result = data;

  if (selectedTable) {
    result = result.filter(
      (kot) => kot.table_name === selectedTable
    );
  }

  // ❌ skip course filter for Bar login (loginType 5)
  if (selectedCourse && Number(loginType) !== 5) {
    result = result.filter(
      (kot) =>
        kot.course_name?.trim().toLowerCase() ===
        selectedCourse.trim().toLowerCase()
    );
  }

  return result;
}, [data, selectedTable, selectedCourse, loginType]);



const tableInstance = useTable(
  { columns, data: filteredData },
  useGlobalFilter,
  useSortBy
);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    tableInstance;

  if (loading) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center text-white bg-gradient-to-b from-blue-900 to-black">
          <p>Loading KOT details...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <audio ref={audioRef} src="/alert.wav" loop />
      <div className="min-h-screen bg-gradient-to-b from-blue-900 to-black p-6 text-white text-sm">
	  {/* 🔵 Branch Cards */}
	  {!hideSelections && (
<div className="mb-6">
  <h2 className="text-sm font-semibold mb-3 text-gray-200">
    Branches
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {branches.map((b, index) => {
      const branchName = b.branch || b.name;
	  const isActive = branchName === selectedBranch;


      return (
        <div
  key={index}
  onClick={() => setSelectedBranch(branchName)}
  className={`p-4 rounded-lg shadow border cursor-pointer transition ${
    isActive
      ? "bg-green-600 bg-opacity-40 border-green-400 scale-[1.02]"
      : "bg-white bg-opacity-10 border-gray-400 hover:bg-opacity-20"
  }`}
>
          <h3 className="text-sm font-bold mb-1">
            {b.name || b.branch}
          </h3>
          <p className="text-xs text-gray-300 mb-2">
            {b.address || "—"}
          </p>

          {isActive && (
            <span className="inline-block text-[10px] px-2 py-0.5 rounded bg-green-500 text-black font-semibold">
              Current Branch
            </span>
          )}
        </div>
      );
    })}
  </div>
</div>
)}

{/* 🔵 Table Cards */}
{/* 🔵 Table Cards */}
{!hideSelections && selectedBranch && (
  <div className="mb-8">

  <h2 className="text-sm font-semibold mb-3 text-gray-200">
    Tables
  </h2>

  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
   {tables.map((t, index) => {
  const isOccupied = String(t.table_booked_status) === "1";
  const isSelected = selectedTable === t.table_name;

  return (
    <div
      key={index}
      onClick={() =>
        setSelectedTable(
          selectedTable === t.table_name ? null : t.table_name
        )
      }
      className={`p-3 rounded-lg text-center border cursor-pointer transition ${
        isSelected
          ? "bg-blue-600 bg-opacity-40 border-blue-400 scale-[1.03]"
          : isOccupied
          ? "bg-red-600 bg-opacity-30 border-red-400"
          : "bg-green-600 bg-opacity-20 border-green-400"
      }`}
    >
      <h3 className="text-sm font-bold">{t.table_name}</h3>

      <p className="text-[10px] mt-1">
        {isSelected
          ? "Selected"
          : isOccupied
          ? "Occupied"
          : "Available"}
      </p>
    </div>
  );
})}


  </div>
</div>

)}

{/* 🔵 Courses Section */}
{!hideSelections && selectedTable && courses.length > 0 && (
  <div className="mb-8">
    <h2 className="text-sm font-semibold mb-3 text-gray-200">
      Courses
    </h2>

    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
      {courses.map((c, index) => {
        const courseName = c.item_name;

        const isSelected = selectedCourse === courseName;

        return (
          <div
            key={index}
            onClick={() =>
              setSelectedCourse(
                isSelected ? null : courseName
              )
            }
            className={`p-3 rounded-lg text-center border cursor-pointer transition ${
              isSelected
                ? "bg-purple-600 bg-opacity-40 border-purple-400 scale-[1.03]"
                : "bg-white bg-opacity-10 border-gray-400 hover:bg-opacity-20"
            }`}
          >
            <h3 className="text-sm font-bold">
              {courseName}
            </h3>

            {isSelected && (
              <p className="text-[10px] mt-1 text-purple-300">
                Selected
              </p>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}


{(hideSelections || selectedCourse) && (
  <>
        <div className="mb-4 text-xs text-gray-300">
          Last updated at: {lastUpdated || "—"}
        </div>
		<div className="flex items-center justify-between mb-2">
  <h1 className="text-xl font-bold">KOT Details</h1>

  <button
    onClick={() =>
      navigate("/checkout", {
        state: {
          table: selectedTable,
          branch: selectedBranch,
        },
      })
    }
    className="px-4 py-1.5 text-sm bg-green-600 hover:bg-green-700 rounded text-white font-semibold"
  >
    Go to Checkout
  </button>
</div>

        <div className="overflow-x-auto bg-white bg-opacity-10 rounded">
          <table
            {...getTableProps()}
            className="min-w-full border border-gray-300 text-xs"
          >
            <thead className="bg-gray-200 bg-opacity-20 text-white">
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="px-2 py-1 border cursor-pointer"
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="hover:bg-gray-100 hover:bg-opacity-20"
                  >
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} className="px-2 py-1 border">
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
  </>
)}

{!hideSelections && selectedCourse && (
<button
  onClick={printAllAcceptedByCourse}
  className="px-4 py-1.5 text-sm bg-purple-600 hover:bg-purple-700 rounded text-white font-semibold"
>
  Print All ({selectedCourse})
</button>
)}

        {/* Status / Cancel Modal */}
        {showModal && selectedKot && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white text-black p-6 rounded-lg shadow-lg w-80">
              <h2 className="text-lg font-bold mb-4">Confirm Action</h2>
              {selectedKot.kot_running_status === 5 ? (
                <>
                  <p className="mb-2">Please enter reason for cancellation:</p>
                  <textarea
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    className="w-full p-2 border rounded mb-4 text-sm"
                    rows="3"
                  />
                </>
              ) : (
                <p className="mb-4">Are you sure you want to change status?</p>
              )}
              <div className="flex justify-end gap-3">
                <button
                  className="px-3 py-1 text-sm bg-gray-400 text-white rounded"
                  onClick={cancelAction}
                >
                  Cancel
                </button>
                <button
                  className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
                  onClick={confirmAction}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
			
        {/* Transfer Modal */}
        {transferModal.show && transferModal.kot && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white text-black p-6 rounded-lg shadow-lg w-80">
              <h2 className="text-lg font-bold mb-4">Transfer Table</h2>
              <p className="mb-2">Select new table for KOT:</p>
              <select
                className="w-full p-2 border rounded mb-4"
                value={newTable}
                onChange={(e) => setNewTable(e.target.value)}
              >
                {activeTables.map((t, i) => (
                  <option key={i} value={t.table_name}>
                    {t.table_name}
                  </option>
                ))}
              </select>
              <div className="flex justify-end gap-3">
                <button
                  className="px-3 py-1 text-sm bg-gray-400 text-white rounded"
                  onClick={cancelTransfer}
                >
                  Cancel
                </button>
                <button
                  className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
                  onClick={confirmTransfer}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default KotsByLogins;
